export default "__VITE_ASSET__B980n_ZG__"